// strings/museum.ts (M2-T10) — museum UI only; the curator's name and lines are the `curator` namespace (M2-T01).
import type { StringBank } from '../schema/strings';
export default {
  title: 'Museum', menuIdentify: 'Identify fossils ({n})', menuDonate: 'Donate', menuHall: 'See the collection', bye: 'Bye',
  hallFossils: 'Fossil hall', hallFish: 'Aquarium', progress: '{n} of {total}', donatedBy: 'Donated by {name}', notYet: 'Not yet found',
  donateTitle: 'Donate to the museum', donateEmpty: 'Nothing in your pockets the museum is missing.',
  hallCompleteToast: 'The {hall} is complete!',
  tankRiver: 'River tank', tankPond: 'Pond tank', tankSea: 'Sea tank', tankFeature: 'Feature tank',
} as const satisfies StringBank;
